// extracted by mini-css-extract-plugin
export default {"spin":"spin___PDiMC","avatar":"avatar___hZiTm","line":"line___UPnss","item":"item___jhJ4e"};